import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';
import { CommonModule } from '@angular/common';
import { BreadCrumb } from '../../models/breadcrumb.model';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  imports: [CommonModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

  private _destroy$: Subject<void> = new Subject<void>();
  public breadcrumbs: BreadCrumb[] = [];
  private _breadcrumbsService: BreadcrumbsService = inject(BreadcrumbsService);
  private _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private _router: Router = inject(Router);
  
  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public ngOnInit(): void {
    this._getBreadcrumbs();
  }

  private _getBreadcrumbs(): void {
    this._breadcrumbsService.breadcrumbs$.pipe(takeUntil(this._destroy$)).subscribe((breadcrumbs: BreadCrumb[]): void => {
      this.breadcrumbs = breadcrumbs;
      this._cdr.detectChanges();
    });
  }

  public navigate(event: string): void {
    this._router.navigateByUrl(event);
  }
}
